import React, {useEffect, useState, useCallback} from 'react';
import {Table, Button, Space, message} from 'antd';
import {EditOutlined, DeleteOutlined, PlusOutlined} from '@ant-design/icons';
import {useNavigate, useParams, useSearchParams} from 'react-router-dom';
import axios from 'axios';
import MathText from "../../components/MathText";
import {API_BASE_URL} from "../../config";

const Questions = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const initialPage = parseInt(searchParams.get('page') || '1', 10);


    const [questions, setQuestions] = useState([]);
    const [pagination, setPagination] = useState({
        current: initialPage,
        pageSize: 10,
    });
    const {collection_id} = useParams();
    const navigate = useNavigate();

    const fetchData = useCallback(async () => {
        try {
            const {data} = await axios.get(`${API_BASE_URL}/api/Question?collectionId=${collection_id}`);
            setQuestions(data);
        } catch (error) {
            message.error('Error fetching questions');
        }
    }, [collection_id]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleDelete = async (id) => {
        try {
            await axios.delete(`${API_BASE_URL}/api/Question/${id}`);
            message.success('Question deleted');
            setQuestions(prev => prev.filter(q => q.id !== id));
        } catch (error) {
            message.error('Delete failed');
        }
    };

    const columns = [
        {
            title: 'Number',
            key: 'id',
            render: (_text, _record, index) =>
                <div>{(pagination.current - 1) * pagination.pageSize + index + 1}</div>,
        },
        {
            title: 'Content',
            key: 'content',
            render: (_, record) => (<MathText text={record.content}/>)
        },
        {title: 'Answer', dataIndex: 'answer', key: 'answer'},
        {
            title: 'Actions',
            key: 'actions',
            render: (_, record, index) => (
                <Space>
                    <Button icon={<EditOutlined/>} type="link"
                            onClick={() =>
                                navigate(`/collection/${collection_id}/question/edit/${record.id}/${
                                    (pagination.current - 1) * pagination.pageSize + index + 1}`)}>
                        Edit
                    </Button>
                    <Button icon={<DeleteOutlined/>} type="link" danger onClick={() => handleDelete(record.id)}>
                        Delete
                    </Button>
                </Space>
            ),
        },
    ];

    return (
        <div>
            <h2>Questions List</h2>
            <Button type="primary" icon={<PlusOutlined/>}
                    onClick={() => navigate(`/collection/${collection_id}/question/add`)}
                    style={{marginBottom: 16}}>
                Add Question
            </Button>
            <Table
                dataSource={questions}
                columns={columns}
                pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                }}
                onChange={(newPagination) => {
                    setPagination(newPagination);
                    setSearchParams({page: newPagination.current});
                }}
                rowKey="id"/>
        </div>
    );
};

export default Questions;
